import { initialModalConfig } from "../../constants";
import { ResponseType } from "../../types/apiTypes";
// import { updateModalConfig } from "../getUniqueMultimedia";

export function mergeWithState(
  existingMessages: any[],
  newMessages: any[],
  existingModalConfig: any,
  newModalConfig: any[]
): any {
  const newModifiedMessages = [...existingMessages, ...newMessages];

  const hasApplyForm = newModalConfig.some((item) => item.type === "apply");

  if (hasApplyForm) {
    const applyModalConfig = {
      open: true,
      data: newModalConfig.find((item) => item.type === "apply"),
      type: ResponseType.ApplyForm,
    };
    return { _messages: newModifiedMessages, _modalConfig: applyModalConfig };
  }

  if (newModalConfig.length === 0) {
    return {
      _messages: newModifiedMessages,
      _modalConfig: initialModalConfig, //{ ...existingModalConfig, open: false }, // Ensure immutability
    };
  }

  const hasVideoOrBlog = newModalConfig.some(
    (item) => item.type === "video" || item.type === "blog"
  );

  let newModalConfiguration;

  if (
    existingModalConfig?.type === "multiMedia" &&
    hasVideoOrBlog &&
    Array.isArray(existingModalConfig.data)
  ) {
    // If data is an array, prepend newModalConfig items
    newModalConfiguration = {
      open: true,
      type: "multiMedia",
      data: newModalConfig, //updateModalConfig(existingModalConfig.data, newModalConfig),
    };
  } else {
    // If data is not initialized or not an array, initialize it with newModalConfig
    newModalConfiguration = {
      open: true,
      type: "multiMedia",
      data: newModalConfig,
    };
  }

  return {
    _messages: newModifiedMessages,
    _modalConfig: newModalConfiguration,
  };
}
